export const PendingContactsModal: string = 'PendingContactsModal';
